import { Chart, registerables } from "chart.js";
import { outlabelsPlugin } from "./labelPlugin";

Chart.register(...registerables);

const DEFAULT_COLORS = [
  "#FB7500",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
  "#8B4513",
  "#FF69B4",
  "#32CD32",
  "#DC143C",
];

interface PieChartConfig {
  data?: number[];
  backgroundColor?: string;
  label: string;
}

const pieChartBase64 = (
  config: PieChartConfig[],
  labels: string[],
): Promise<string> => {
  return new Promise((resolve) => {
    // Responsive treatment
    const isMobile = window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;

    const width = isMobile ? 600 : isTablet ? 900 : 1200;
    const height = isMobile ? 400 : isTablet ? 600 : 800;

    const fontScale = isMobile ? 0.25 : isTablet ? 0.6 : 1;
    const paddingScale = isMobile ? 0.3 : isTablet ? 0.6 : 1;
    const borderScale = isMobile ? 0.4 : isTablet ? 0.7 : 1;

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.style.position = "absolute";
    canvas.style.left = "-9999px";

    document.body.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    if (ctx) {
      const chart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: labels,
          datasets: [
            ...config.map((data) => {
              const { label, data: _data, backgroundColor, ...rest } = data;

              return {
                label: label,
                data: _data,
                backgroundColor: backgroundColor ?? DEFAULT_COLORS,
                tension: 0.3,
                borderWidth: 2 * borderScale,
                ...rest,
              };
            }),
          ],
        },
        options: {
          animation: {
            duration: 0,
          },
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: Math.round(80 * paddingScale),
              bottom: Math.round(80 * paddingScale),
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
            outlabels: {
              text: "%l %p",
              color: "white",
              stretch: 30,
              font: {
                resizable: true,
                minSize: Math.round(12 * fontScale),
                maxSize: Math.round(30 * fontScale),
              },
            },
          } as any,
        },
        plugins: [outlabelsPlugin],
      });

      setTimeout(() => {
        const base64 = canvas.toDataURL("image/png");
        chart.destroy();
        document.body.removeChild(canvas);
        resolve(base64);
      }, 100);
    } else {
      document.body.removeChild(canvas);
      resolve("");
    }
  });
};

export default pieChartBase64;
